import { removeUserToken } from '../user-hash';

export const clearLocalStorageHelper = () => {
  removeUserToken();
  localStorage.removeItem('userSearchType');
  localStorage.removeItem('paginationInfo');
  localStorage.removeItem('dealer');
  localStorage.removeItem('isAuthenticated');
  localStorage.removeItem('loginTime');
  localStorage.removeItem('client-iin-search');
  localStorage.removeItem('bankShares');
};
